import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { BaseComponent } from '../../shared/components/base/base.component';
import { TitleService } from '../../shared/services/title.service';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  standalone: true,
  imports: [CommonModule, MatCardModule],
})
export class SupportComponent extends BaseComponent implements OnInit {
  constructor(private titleService: TitleService) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.titleService.setTitle(`Support`);
  }
}
